module.exports = __webpack_public_path__ + "img/cuttheprice.a5f4827b.jpg";